import { axiosInstance } from "./instance";

export const getInfoUserShoppingExpress = (uuid, prod, label = "prod") => {
  return axiosInstance.get(`shopping-express-payment/${uuid}?${label}=${prod}`);
};

export const getInfoProductShopping = (uuid, prod, venue, label = "prod") => {
  return axiosInstance.get(
    `shopping-express-payment/prices/${uuid}?${label}=${prod}&venue=${venue}`
  );
};

export const postPaymentShopping = (body) => {
  return axiosInstance.post("shopping-express-payment/pay", body);
};

export const getDetailShoppingExpress = (uuid) => {
  return axiosInstance.get(`shopping-express-payment/detail/${uuid}`);
};
